import axios from "axios";

const authConfig = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// Nombre d'abonnés newsletter
const getSubscriberCount = async (token) => {
  const { data } = await axios.get('/api/newsletter/subscriber-count', authConfig(token));
  return data.count;
};

// Stats des articles déjà envoyés : [{ slug, sendCount, recipients, lastSentAt }]
const getSentArticles = async (token) => {
  const { data } = await axios.get('/api/newsletter/sent-articles', authConfig(token));
  return data.articles;
};

// Prévisualisation HTML de l'email d'un article (sans envoi)
const previewArticle = async (article, token) => {
  const { data } = await axios.post('/api/newsletter/preview-article', article, authConfig(token));
  return data; // { subject, html }
};

// Envoi de l'article à tous les abonnés
const sendArticle = async (article, token) => {
  const { data } = await axios.post('/api/newsletter/send-article', article, authConfig(token));
  return data; // { message, sent, total }
};

// Inscription publique à la newsletter (depuis le blog) — pas d'authentification
const subscribeNewsletter = async (email) => {
  const { data } = await axios.post('/api/contact/newsletter', { email });
  return data; // { message }
};

export { getSubscriberCount, getSentArticles, previewArticle, sendArticle, subscribeNewsletter };
